import * as React from "react";
const SvgFiRrHandPaper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-paper_svg__a)">
      <path
        fill="#062147"
        d="M22.943 3.714a3.01 3.01 0 0 0-2.439-.674 2.8 2.8 0 0 0-.609.172A3.006 3.006 0 0 0 17.001.999c-.535 0-1.037.141-1.472.388a3 3 0 0 0-2.528-1.388 3.005 3.005 0 0 0-2.895 2.213 3 3 0 0 0-.609-.173 3.01 3.01 0 0 0-2.439.674 3 3 0 0 0-1.057 2.286v8.698l-.956-.893a3 3 0 0 0-4.234.145 3.003 3.003 0 0 0 .13 4.231l3.294 3.176a12.94 12.94 0 0 0 9.023 3.642h1.743c4.962 0 9-4.038 9-9V6c0-.881-.386-1.714-1.058-2.286M22 15c0 3.86-3.14 7-7 7h-1.743a10.95 10.95 0 0 1-7.635-3.081l-3.304-3.186a1 1 0 0 1 1.362-1.465l2.638 2.463A1.002 1.002 0 0 0 8.001 16V5c0-.294.128-.572.353-.762.228-.193.52-.272.823-.224.462.076.825.556.825 1.093V10a1 1 0 0 0 2 0V3c0-.551.45-1 1-1 .551 0 1 .449 1 1v7a1 1 0 0 0 2 0V4c0-.551.45-1 1-1 .551 0 1 .449 1 1v6a1 1 0 0 0 2 0V6.107c0-.538.362-1.018.825-1.093.303-.047.595.03.823.224.224.19.353.468.353.762v9z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-paper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandPaper;
